import { Controller } from "@hotwired/stimulus"
import { changerIcone } from "../lib/icones"

// Tiny show/hide for password fields. Wraps an <input type="password"> + a
// trigger button; toggling flips the input's type and swaps the trigger's
// icône Lucide entre eye et eye-off.
export default class extends Controller {
  static targets = ["input"]

  toggle(event) {
    if (!this.hasInputTarget) return
    const input = this.inputTarget
    const showing = input.type === "text"
    input.type = showing ? "password" : "text"

    changerIcone(event.currentTarget.querySelector(".lucide"), showing ? "eye" : "eye-off")
  }
}
